import { createLogger } from '@/lib/logging'

export const appLogger = createLogger()

